<template>
  <div style="clear: both;">
    <v-textarea :label="$t('Status')" name="status" variant="underlined" :model-value="statusName" readonly auto-grow rows="1"  density="comfortable"></v-textarea>
  </div>
</template>

<script>
export default {
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    statusName: function() {
      return this.modelValue.name
    }
  }
}
</script>

<style scoped></style>
